export const ContentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.7907 20H7.2093C2.15814 20 0 17.8419 0 12.7907V7.2093C0 2.15814 2.15814 0 7.2093 0H11.8605C12.2419 0 12.5581 0.316279 12.5581 0.697674C12.5581 1.07907 12.2419 1.39535 11.8605 1.39535H7.2093C2.92093 1.39535 1.39535 2.92093 1.39535 7.2093V12.7907C1.39535 17.0791 2.92093 18.6047 7.2093 18.6047H12.7907C17.0791 18.6047 18.6047 17.0791 18.6047 12.7907V8.13953C18.6047 7.75814 18.9209 7.44186 19.3023 7.44186C19.6837 7.44186 20 7.75814 20 8.13953V12.7907C20 17.8419 17.8419 20 12.7907 20Z"
        fill="#292D32"
      />
      <path
        d="M19.3023 8.83719H15.5814C12.4 8.83719 11.1628 7.59997 11.1628 4.41857V0.697644C11.1628 0.418574 11.3302 0.158109 11.5907 0.0557836C11.8512 -0.0558443 12.1488 0.00927192 12.3535 0.204621L19.7953 7.64648C19.9907 7.84183 20.0558 8.14882 19.9442 8.40928C19.8325 8.66975 19.5814 8.83719 19.3023 8.83719ZM12.5581 2.38136V4.41857C12.5581 6.81857 13.1814 7.44183 15.5814 7.44183H17.6186L12.5581 2.38136Z"
        fill="#292D32"
      />
      <path
        d="M10.9303 11.6279H5.34886C4.96746 11.6279 4.65118 11.3116 4.65118 10.9302C4.65118 10.5488 4.96746 10.2325 5.34886 10.2325H10.9303C11.3116 10.2325 11.6279 10.5488 11.6279 10.9302C11.6279 11.3116 11.3116 11.6279 10.9303 11.6279Z"
        fill="#292D32"
      />
      <path
        d="M9.06979 15.3488H5.34886C4.96746 15.3488 4.65118 15.0326 4.65118 14.6512C4.65118 14.2698 4.96746 13.9535 5.34886 13.9535H9.06979C9.45118 13.9535 9.76746 14.2698 9.76746 14.6512C9.76746 15.0326 9.45118 15.3488 9.06979 15.3488Z"
        fill="#292D32"
      />
    </svg>
  );
};
